import { render, staticRenderFns } from "./DetailedBording.vue?vue&type=template&id=66ca8e1e"
import script from "./DetailedBording.vue?vue&type=script&lang=js"
export * from "./DetailedBording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports